import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export class LCDQueryClient {
  constructor({
    requestClient
  }) {
    _defineProperty(this, "req", void 0);
    this.req = requestClient;
    this.allRateLimits = this.allRateLimits.bind(this);
    this.rateLimit = this.rateLimit.bind(this);
    this.rateLimitsByChainId = this.rateLimitsByChainId.bind(this);
    this.rateLimitsByChannelId = this.rateLimitsByChannelId.bind(this);
  }
  /* AllRateLimits */

  async allRateLimits(_params = {}) {
    const endpoint = `Stride-Labs/stride/ratelimit/ratelimits`;
    return await this.req.get(endpoint);
  }
  /* RateLimit */

  async rateLimit(params) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }
    const endpoint = `Stride-Labs/stride/ratelimit/ratelimit/${params.channelId}/by_denom`;
    return await this.req.get(endpoint, options);
  }
  /* RateLimitsByChainId */

  async rateLimitsByChainId(params) {
    const endpoint = `Stride-Labs/stride/ratelimit/ratelimits/${params.chainId}`;
    return await this.req.get(endpoint);
  }
  /* RateLimitsByChannelId */

  async rateLimitsByChannelId(params) {
    const endpoint = `Stride-Labs/stride/ratelimit/ratelimits/${params.channelId}`;
    return await this.req.get(endpoint);
  }
}